import { Tabs, TabsProps } from "antd";
import React from "react";
import BidInformation from "./BidInformation";
import BidsRecieved from "./BidsRecieved";

const BidTabbtn = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Bid Information",
      children: <BidInformation />,
    },
    {
      key: "2",
      label: "Bids Recieved",
      children: <BidsRecieved />,
    },
  ];
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default BidTabbtn;
